// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c9d4918d","74":"19ea003d","125":"7ad30510","162":"763883f6","165":"5e7d97be","217":"dc48a581","405":"8a54d571","453":"9e1e7267","563":"2c87c8a2","574":"6d95015b","609":"11209173","639":"60ada561","642":"06aae351","685":"45ad9042"}[chunkId] + ".chunk.js";
};